/**
 * correspondentRouterModule 通讯员路由
 */
"use strict";
angular.module("correspondentRouterModule", [
        "editCorrespondentModule",
    ])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state("manageconfig.groupmanage.correspondent.editcorrespondent", { //新建/编辑通讯员
                url: '/editcorrespondent?correspondentId',
                views: {
                    'right@manageconfig.groupmanage': {
                        templateUrl: './manageConfig/groupUserManageMent/correspondent/editCorrespondent/editCorrespondent_tpl.html',
                        controller: 'editCorrespondentController'
                    }
                }
            });
    }]);